import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { EmpresaService } from 'src/app/dashboard/services/empresa.service';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent implements OnInit {
  validatingForm: FormGroup;
  IsHiddenForm: boolean = false;

  constructor(
    private empresaService: EmpresaService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    let language = this.auth.getLanguage();
    if (!language) language = 'es';
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalOrden: new FormControl('', [
        Validators.pattern(/^\d+$/),
        CustomValidators.secureInput
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ]),
    });
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalOrden() {
    return this.validatingForm.get('signupFormModalOrden');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  addCompany() {
    if (this.validatingForm.invalid) {
      this.toastr.error(this.translate.instant('texto_815'), this.translate.instant('texto_813'));
      return;
    }

    const sociedad = this.auth.getSociedad();
    const id = this.signupFormModalId.value;
    const nombre = this.signupFormModalName.value;
    const comentario = this.contactFormModalMessage.value;

    this.empresaService.addCompany(sociedad, id, nombre, comentario).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_185'), this.translate.instant('texto_186'));
        } else {
          this.toastr.error(this.translate.instant('texto_187'), this.translate.instant('texto_186'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/empresas']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_187'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_187'), this.translate.instant('texto_813'));
        }
      });
  }

  hideModal() {
    this.IsHiddenForm = false;
  }
}
